




























































import {Component, Vue} from "vue-property-decorator";
import {getContactList} from "@/services/api"
import {Contact} from "@/model/Contact";
import {PageInfo} from "@/model/Resp";
import YcAside from "@/components/common/yc-aside.vue"
import YcHeader from "@/components/common/yc-header.vue"
import {defaultTimezone} from "@/services/config";
import {timezoneChange} from "@/services/common";

@Component({
  components: {
    'yc-header': YcHeader,
    'yc-aside': YcAside
  },
})
export default class UserManagement extends Vue {
  public subscribeStatusMap: Record<number, string> = {
    0: 'views.usermanagement.text_672a8ba29605',
    1: 'views.usermanagement.text_5df28ba29605',
    2: 'views.usermanagement.text_53d66d888ba29605',
  }
  public tableData: Contact[] = [];
  public pageInfo: PageInfo = {
    currentPage: 1,
    pageSize: 20,
    total: 0
  }
  public timezone = localStorage.getItem("timezone") || defaultTimezone;
  loading = false

  created(): void {
    this.getContactList();
  }

  /**
   * 获取联系人列表
   */
  getContactList(): void {
    this.loading = true
    getContactList({currentPage: this.pageInfo.currentPage, pageSize:this.pageInfo.pageSize})
      .then(res => {
      this.loading = false
      this.tableData = res.data.data;
      this.tableData.map(contact => {
          contact.firstActive = timezoneChange(contact.firstActive,'GMT+0800', this.timezone);
          contact.lastActive = timezoneChange(contact.lastActive,'GMT+0800', this.timezone);
      })
      if (res.data.pageInfo) {
        this.pageInfo = res.data.pageInfo;
      }
    })
  }

    // 将邮箱地址的用户名部分进行掩码处理
  maskEmail(email) {
    const companyId = JSON.parse(localStorage.getItem('companyInfo')).id;
  const targetCompany = [431, 459, 450, 461, 453, 472, 468, 470, 465, 457, 467, 469, 30];
  if (targetCompany.includes(companyId)) {
    let maskedEmail = "";
    const atIndex = email.indexOf("@");
    const name = email.substring(0, atIndex);
    const domain = email.substring(atIndex + 1);
    const maskedName = name.substring(0, 3) + "****";
    maskedEmail = maskedName + "@" + domain;
    return maskedEmail;
  } else {
    return email;
  }
}

  /**
   * 查询
   */
  search(): void {
    this.pageInfo.currentPage = 1;
    this.getContactList();
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.pageInfo.pageSize = val;
    this.pageInfo.currentPage = 1;
    this.getContactList();
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.pageInfo.currentPage = val;
    this.getContactList();
  }
}
